import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { GAMES } from '../constants/gamesConfig'
import { trackPageView } from '../utils/analytics'
import { useEffect } from 'react'

// NYT-Games-style game picker, the app's new root route. Each game owns its
// own mode-select/gameplay sub-routes beneath GAMES[slug].route - this page
// only ever links out, it holds no game-specific logic.
export const PortalHomePage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    try {
      trackPageView({ page: '/' })
    } catch (error) {
      console.error('Failed to track portal home page view:', error)
    }
  }, [])

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  }

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 },
  }

  return (
    <div className="mode-selection">
      <p className="mode-subtitle">Pick a puzzle to play today</p>

      <motion.div
        className="mode-cards"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {Object.values(GAMES).map((game) => (
          <motion.div key={game.slug} variants={item}>
            <div
              className="mode-card"
              data-hj-clickable="true"
              onClick={() => navigate(game.route)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate(game.route)
              }}
            >
              <h2>{game.name}</h2>
              <p>{game.tagline}</p>
              <div className="text-center mt-auto">
                <button className="play-button" onClick={() => navigate(game.route)}>
                  Play
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}
